import React from 'react';
import {Switch} from 'react-router-dom';
import {useIntl} from 'react-intl';

import PrivateRoute from '../../components/PrivateRoute';
import withLayout from '../../components/ui/Layout';
import RelevancePage from './RelevancePage';

function Relevance() {
    const intl = useIntl();

    return (
        <Switch data-test='relevanceComponent'>
            <PrivateRoute
                permission='REPORTS_DASHBOARD'
                exact
                path='/relevance'
                component={withLayout(
                    RelevancePage,
                    intl.formatMessage({id: 'ROUTES.RELEVANCE.INDEX'}),
                )}
            />
        </Switch>
    );
}

export default Relevance;
